var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"lazy",attrs:{"data-srcset":_vm.generateSources(_vm.img.imgs),"width":_vm.img.width,"height":_vm.img.height,"src":_vm.generateSVGCode}})}
var staticRenderFns = []

export { render, staticRenderFns }